import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { api } from "../../libs/axios";
import { AxiosErrorResponse } from "../pdv/mutationReserva";
import { queryClient } from "../../libs/queryClient";
import { formUsuarioEditar } from "../../schemas/usuario";

export function useMutationEditarUsuario(id?: string) {
  return useMutation({
    mutationFn: async (data: formUsuarioEditar) => {
      const payload = {
        ...data,
        password: data.password?.trim() ? data.password : undefined,
      };

      const response = await api.patch(`/usuario/${id}`, payload);

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['usuarios-lista'],
        exact: false,
      });
      await queryClient.invalidateQueries({
        queryKey: ['usuario-detalhe', { id }],
        exact: true,
      });

      Swal.fire({
        title: 'Usuário atualizado',
        icon: 'success'
      });
    },
    onError: (err: AxiosErrorResponse) => {
      const requestId = err.response?.headers?.['request-id'];

      Swal.fire({
        title: "Erro ao salvar",
        icon: "error",
        text: `${err.response?.data?.data?.message || "Erro desconhecido"} ${requestId ? `- Request ID: ${requestId}` : ''}`,
      });
    }
  });
}
